import { useTranslation } from 'react-i18next';
import { useVehicleApi } from '@hero/api-hooks';
import { TruckIcon } from '@hero/web-icons';
import type { Id } from '@hero/schema';
import { EntityLink } from './EntityLink';

export interface VehicleCardWidgetProps {
  vehicleId: Id;
  displaySnapshot?: { plate?: string; type?: string };
}

export const VehicleCardWidget = ({ vehicleId, displaySnapshot }: VehicleCardWidgetProps) => {
  const { t } = useTranslation('m-agent');
  const { data: vehicle } = useVehicleApi(vehicleId);
  const plate =
    vehicle?.registration?.plate ??
    displaySnapshot?.plate ??
    t('widgets.vehicle_card.fallback', 'Vehicle');
  const type = vehicle?.classification?.type ?? displaySnapshot?.type;

  return (
    <EntityLink
      kind='vehicle'
      entityId={String(vehicleId)}
      label={plate}
      subtitle={type}
      icon={<TruckIcon className='size-4' />}
    />
  );
};
